function _newArrowCheck(n, r) {
  if (n !== r) throw new TypeError("Cannot instantiate an arrow function");
}
module.exports = _newArrowCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/helpers/newArrowCheck.js
// module id = 1183
// module chunks = 6 7 17 18